























import { Component, Vue } from "vue-property-decorator";

import commons from "@/common/store/modules/commons";
import AuthApi from "@/general/api/authApi";

@Component({ components: {} })
export default class TheSimpleHeader extends Vue {
  serviceLogoStyle: any = {};

  page_logo = "";

  get colorCode() {
    return commons?.colorCode;
  }

  get serviceName() {
    return commons?.serviceName;
  }

  get serviceLogo() {
    //#59042�Ή��ɂ��Z�b�V������񂩂�page_logo���擾����悤�ɏC��
    //return commons?.OrgPageSpecific?.page_logo;
    return this.page_logo;
  }

  // mounted() {
  //   this.initServiceLogoStyle();
  // }

  async created() {
    commons.setOrgPageSpecificDataFromLocalStorage();
    //#59042�Ή��ɂ��Z�b�V������񂩂�page_logo���擾����悤�ɏC��
    await AuthApi.getICSession()
    .then((result) => {
        const ic_session = JSON.parse(result);
        this.page_logo = ic_session.pageLogo;
    })
    .catch(() => {
      this.page_logo = "";
    });
  }

  // initServiceLogoStyle() {
  // const { serviceLogo } = this;
  // const rem = 16;
  // const maxWidth = 3; // serviceLogo.width / rem;

  // this.serviceLogoStyle = {
  //   maxWidth: `${maxWidth}rem`,
  // };
  // }

  get isAdminSite() {
    return false;
  }
}
